/**
 * MODULE: domain/templates/frontend/api/prospectBrandApi.ts
 * PURPOSE: client — POST /api/v1/slide-decks/prospect-brand/extract
 * DEPENDENCIES: @shared/lib/frontend/api/config
 * PUBLIC_API: prospectBrandApi, ProspectBrandOverlay
 * SIDE_EFFECTS: HTTP
 * AGENT_SAFETY: 🟢 SAFE
 * FILE_SIZE: ~55 / 100 lines
 * RECENT: 2026-08-04 [2.2.2045] — prospect brand extract client.
 */

import { API_CONFIG, getAuthHeaders } from '@shared/lib/frontend/api/config';

const BASE = `${API_CONFIG.baseURL.replace(/\/$/, '')}/api/v1/slide-decks`;

export interface ProspectBrandOverlay {
  source: string;
  org: string;
  name?: string | null;
  description?: string | null;
  blog?: string | null;
  html_url?: string | null;
  logo_url?: string | null;
  primary_color: string;
  accent_color: string;
  secondary_color: string;
  background_color: string;
  fetched_at: string;
}

export const prospectBrandApi = {
  /**
   * Extract public GitHub org brand signals. Returns null on 404 / network failure
   * so callers can fall back to tenant Brand Kit.
   */
  async extract(githubOrgUrl: string): Promise<ProspectBrandOverlay | null> {
    const url = (githubOrgUrl || '').trim();
    if (!url) return null;
    try {
      const response = await fetch(`${BASE}/prospect-brand/extract`, {
        method: 'POST',
        headers: {
          ...getAuthHeaders(),
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ github_org_url: url }),
      });
      if (!response.ok) return null;
      return (await response.json()) as ProspectBrandOverlay;
    } catch {
      return null;
    }
  },
};
